import { render, staticRenderFns } from "./IframeView.vue?vue&type=template&id=ac45c11e&scoped=true&"
import script from "./IframeView.vue?vue&type=script&lang=js&"
export * from "./IframeView.vue?vue&type=script&lang=js&"
import style0 from "./IframeView.vue?vue&type=style&index=0&id=ac45c11e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac45c11e",
  null
  
)

export default component.exports